/* KIJICO Hero Slider JS */
function initSlider(slider) {
  const slides = slider.querySelectorAll('.hero-slider__slide');
  const dots = slider.querySelectorAll('.hero-slider__dot');
  const prevBtn = slider.querySelector('.hero-slider__arrow--prev');
  const nextBtn = slider.querySelector('.hero-slider__arrow--next');
  if (slides.length === 0) return;

  let current = 0;
  let autoplayTimer;
  const speed = (parseInt(slider.dataset.autoplay) || 5) * 1000;

  function showSlide(index) {
    slides.forEach(function(s) { s.style.display = 'none'; s.classList.remove('is-active'); });
    slides[index].style.display = 'block';
    slides[index].classList.add('is-active');
    dots.forEach(function(d, i) { d.classList.toggle('active', i === index); });
    current = index;
  }

  function nextSlide() { showSlide((current + 1) % slides.length); }
  function prevSlide() { showSlide((current - 1 + slides.length) % slides.length); }

  function startAutoplay() {
    if (slides.length > 1) {
      autoplayTimer = setInterval(nextSlide, speed);
    }
  }
  function resetAutoplay() {
    clearInterval(autoplayTimer);
    startAutoplay();
  }

  showSlide(0);
  startAutoplay();

  if (prevBtn) prevBtn.addEventListener('click', function() { prevSlide(); resetAutoplay(); });
  if (nextBtn) nextBtn.addEventListener('click', function() { nextSlide(); resetAutoplay(); });
  dots.forEach(function(dot, i) {
    dot.addEventListener('click', function() { showSlide(i); resetAutoplay(); });
  });
}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.hero-slider').forEach(initSlider);
});

document.addEventListener('shopify:section:load', function(event) {
  var slider = event.target.querySelector('.hero-slider');
  if (slider) initSlider(slider);
});
